import type { ApiCourseListItem } from '@/types/course'

// หาราคาต่อคนจาก price_tiers ตามจำนวนคนที่เลือก — ตรรกะเดียวกับ resolve_unit_price() ฝั่ง backend (course_form_utils.py)
// ไม่ได้ตั้ง price_tiers ไว้ (null/[]) = ใช้ course.price ปกติเสมอ ไม่ว่าจำนวนคนเท่าไหร่
export function resolveUnitPrice(course: Pick<ApiCourseListItem, 'price' | 'price_tiers'>, quantity: number): number {
  const tiers = course.price_tiers
  if (tiers && tiers.length > 0) {
    const match = tiers.find((t) => t.min_qty <= quantity && (t.max_qty == null || quantity <= t.max_qty))
    if (match) return match.price
  }
  return course.price
}

// ราคาก่อนลดคู่กับ resolveUnitPrice — ใช้โชว์ขีดฆ่า ไม่ใช้คำนวณยอดจ่ายจริง
export function resolveOriginalPrice(course: Pick<ApiCourseListItem, 'original_price' | 'price_tiers'>, quantity: number): number | null {
  const tiers = course.price_tiers
  if (tiers && tiers.length > 0) {
    const match = tiers.find((t) => t.min_qty <= quantity && (t.max_qty == null || quantity <= t.max_qty))
    if (match) return match.original_price
  }
  return course.original_price
}
